export default [
  {
    path: '/avplanPmp/',
    name: '/avplanPmp/',
    component: () => import('../views/Main'),
    children: [
      // {
      //   path: '/avplanPmp/templateBind',
      //   name: '/avplanPmp/templateBind',
      //   component: () => import('../vuePanel/vueDraggablePanel')
      // },
      {
        path: '/avplanPmp/panel',
        name: '/avplanPmp/panel',
        component: () => import('../views/d3dragPanel/panel')
      },
      {
        path: '/avplanPmp/TaskNodeTimeLine',
        name: '/avplanPmp/TaskNodeTimeLine',
        component: () => import('../views/d3dragPanel/TaskNodeTimeLine')
      },
      {
        path: '/avplanPmp/taskProcess/taskState',
        name: '/avplanPmp/taskProcess/taskState',
        component: () => import('../views/menuList/taskProcess/taskState')
      }
    ]
  },
  {
    path: '/word',
    name: '/word',
    component: () => import('../components/filePreView/Word')
  },
  {
    path: '/log',
    name: '/log',
    component: () => import('../views/updateLog/timelineLog')
  }
]
